// import React, { useState, useEffect } from 'react'
// import axios from 'axios'
// import './finalpage.css'
// import { data, useParams } from 'react-router'

// const ProcessComplete = () => {
//   const { claimNumber } = useParams()
//   console.log('7', claimNumber)
//   const [Data, setData] = useState(null)
//   const [claimDetails, setClaimDetails] = useState(null)
//   const [loading, setLoading] = useState(true)
//   const [progressData, setProgressData] = useState({})
//   useEffect(() => {
//     if (!claimNumber) return

//     const fetchClaimDetails = async () => {
//       try {
//         const response = await axios.post(
//           `/process_data/get_claim_details/${claimNumber}`
//         )
//         console.log('Claim details response:', response.data)
//         setClaimDetails(response.data)
//       } catch (error) {
//         console.error('Error fetching claim details:', error)
//       } finally {
//         setLoading(false)
//       }
//     }

//     fetchClaimDetails()
//   }, [claimNumber])
//   useEffect(() => {
//     const fetchProgress = async () => {
//       if (claimNumber) {
//         try {
//           const res = await axios.post(
//             `/process_data/claim_progress/${claimNumber}`
//           )
//           setProgressData(res.data)
//           console.log('progress-32', res.data)
//         } catch (err) {
//           console.error('Error fetching claim progress:', err)
//         }
//       }
//     }
//     fetchProgress()
//   }, [claimNumber])
//   useEffect(() => {
//     if (!claimNumber || !progressData) return

//     if (progressData.pre_invoice == '1') {
//       console.log('43-pre-invoice-extract')

//       axios
//         .post(`/server/get-pre-invoice-data/${claimNumber}`)
//         .then(response => {
//           console.log('pre-invoice data', response.data)
//           setData(response.data)
//         })
//         .catch(error => console.error('Axios error:', error))
//     } else {
//       console.log('54-invoice-extract')

//       axios
//         .post(`/server/get-invoice-data/${claimNumber}`)
//         .then(response => {
//           console.log('invoice data', response.data)
//           setData(response.data)
//         })
//         .catch(error => console.error('Axios error:', error))
//     }
//   }, [claimNumber, progressData])
//   return (
//     <div className='process-payment-container'>
//       <h2 className='status-payment-text'>Process Complete</h2>
//       <div className='info-payment-text'>
//         <p>
//           Policy: <strong>{claimDetails?.policy_number}</strong>
//         </p>
//         <p>
//           Vehicle: <strong>{claimDetails?.vehicle_number}</strong>
//         </p>
//       </div>
//       <div className='circle-payment-container'>
//         <div className='circle-payment'>9/9</div>
//       </div>
//       <p className='claim-payment-number'>{claimNumber}</p>
//       <p className='steps-payment-status'>9 of 9 steps are completed.</p>
//       <p className='final-payment-amount'>Final Settled Amount ₹ {data?.final_calculation?.digit_liability}</p>
//       {/* <p className='utr-payment'>UTR 10DFKKF859485VJFKDF</p> */}
//     </div>
//   )
// }

// export default ProcessComplete

// import React, { useState, useEffect } from 'react'
// import axios from 'axios'
// import './finalpage.css'
// import { useParams } from 'react-router'

// const ProcessComplete = () => {
//   const { claimNumber } = useParams()
//   const [data, setData] = useState(null)
//   const [claimDetails, setClaimDetails] = useState(null)
//   const [loading, setLoading] = useState(true)
//   const [progressData, setProgressData] = useState({})

//   useEffect(() => {
//     if (!claimNumber) return

//     const fetchClaimDetails = async () => {
//       try {
//         const response = await axios.post(`/process_data/get_claim_details/${claimNumber}`)
//         setClaimDetails(response.data)
//       } catch (error) {
//         console.error('Error fetching claim details:', error)
//       }
//     }

//     fetchClaimDetails()
//   }, [claimNumber])

//   useEffect(() => {
//     const fetchProgress = async () => {
//       if (claimNumber) {
//         try {
//           const res = await axios.post(`/process_data/claim_progress/${claimNumber}`)
//           setProgressData(res.data)
//         } catch (err) {
//           console.error('Error fetching claim progress:', err)
//         }
//       }
//     }
//     fetchProgress()
//   }, [claimNumber])

//   useEffect(() => {
//     const fetchData = async () => {
//       if (!claimNumber || !progressData) return

//       try {
//         let res
//         if (progressData.pre_invoice === '1') {
//           res = await axios.post(`/server/get-pre-invoice-data/${claimNumber}`)
//         } else {
//           res = await axios.post(`/server/get-invoice-data/${claimNumber}`)
//         }
//         setData(res.data)
//       } catch (error) {
//         console.error('Axios error:', error)
//       } finally {
//         setLoading(false)
//       }
//     }

//     fetchData()
//   }, [claimNumber, progressData])

//   if (loading) {
//     return (
//       <div className='loader-overlay'>
//         <div className='loader'></div>
//       </div>
//     )
//   }

//   return (
//     <div className='process-payment-container'>
//       <h2 className='status-payment-text'>Process Complete</h2>
//       <div className='info-payment-text'>
//         <p>
//           Policy: <strong>{claimDetails?.policy_number}??''</strong>
//         </p>
//         <p>
//           Vehicle: <strong>{claimDetails?.vehicle_number}</strong>
//         </p>
//       </div>
//       <div className='circle-payment-container'>
//         <div className='circle-payment'>9/9</div>
//       </div>
//       <p className='claim-payment-number'>{claimNumber}</p>
//       <p className='steps-payment-status'>9 of 9 steps are completed.</p>
//       <p className='final-payment-amount'>
//         Final Settled Amount ₹ {data?.final_calculation?.digit_liability}
//       </p>
//     </div>
//   )
// }

// export default ProcessComplete
import React, { useState, useEffect } from 'react'
import axios from 'axios'
import './finalpage.css'
import { useParams } from 'react-router'

const ProcessComplete = () => {
  const { claimNumber } = useParams()
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(true)
  const [progressData, setProgressData] = useState({})
  
  const [claimDetails, setClaimDetails] = useState(null)
  useEffect(() => {
    if (!claimNumber) return

    const fetchClaimDetails = async () => {
      try {
        const response = await axios.post(
          `/process_data/get_claim_details/${claimNumber}`
        )
        console.log("212",response.data);
        
        setClaimDetails(response.data)
      } catch (error) {
        console.error('Error fetching claim details:', error)
      }
    }

    fetchClaimDetails()
  }, [claimNumber])

  useEffect(() => {
    const fetchProgress = async () => {
      if (claimNumber) {
        try {
          const res = await axios.post(
            `/process_data/claim_progress/${claimNumber}`
          )
          setProgressData(res.data)
        } catch (err) {
          console.error('Error fetching claim progress:', err)
        }
      }
    }
    fetchProgress()
  }, [claimNumber])

  useEffect(() => {
    const fetchData = async () => {
      if (!claimNumber || !progressData) return

      try {
        let response
        if (progressData.pre_invoice === '1') {
          response = await axios.post(`/server/get-pre-invoice-data/${claimNumber}`)
        } else {
          response = await axios.post(`/server/get-invoice-data/${claimNumber}`)
        }
        console.log("248",response.data);
        
        setData(response.data)
      } catch (error) {
        console.error('Axios error:', error)
      } finally {
        setLoading(false)
      }
    }

    fetchData()
  }, [claimNumber, progressData])

  if (loading) {
    return (
      <div style={{
        height: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}>
        <div
          style={{
            border: '5px solid #f3f3f3',
            borderTop: '5px solid #ff0083',
            borderRadius: '50%',
            width: '60px',
            height: '60px',
            animation: 'spin 1s linear infinite'
          }}
        />
        <style>
          {`
            @keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
          `}
        </style>
      </div>
    )
  }

  const finalAmount = data?.final_calculation?.digit_liability || 'N/A'

  return (
    <div className='process-payment-container'>
      <h2 className='status-payment-text'>Process Complete</h2>
      <div className='info-payment-text'>
        <p>
          Policy: <strong>{claimDetails?.policy_number || 'N/A'}</strong>
        </p>
        <p>
          Vehicle: <strong>{claimDetails?.vehicle_number || 'N/A'}</strong>
        </p>
      </div>
      <div className='circle-payment-container'>
        <div className='circle-payment'>9/9</div>
      </div>
      <p className='claim-payment-number'>{claimNumber || 'N/A'}</p>
      <p className='steps-payment-status'>9 of 9 steps are completed.</p>
      <p className='final-payment-amount'>
        Final Settled Amount ₹ {finalAmount}
      </p>
    </div>
  )
}

export default ProcessComplete
